import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'padnumber' })
export class PadNumberPipe implements PipeTransform {
  transform(value: number): string {
    return `${value}`.padStart(2, '0');
  }
}
